import type { DBAccount } from "@/local-shared/model";

export function isTwitchConnected(profileData: Partial<DBAccount>|null): boolean
{
    if (!profileData)
    {
        return false;
    }

    if (profileData.connection?.startsWith("twitch")) return true;

    if (profileData.connections)
    {
        return profileData.connections.some((conn) => typeof conn === "object" && conn.profileID.startsWith("twitch|"));
    }

    return false;
}
